// policyName, environmentGroupIds, isCreating

import { confirm } from '@@/modals/confirm';
import { buildConfirmButton } from '@@/modals/utils';

import { useEnvironmentList } from '../../environments/queries';

export function useConfirmDistributePolicyModal(
  policyName: string,
  environmentGroupIds: number[]
) {
  const { environments } = useEnvironmentList();

  const totalEnvironmentsAcrossGroups = environments.reduce(
    (acc, environment) => {
      if (environmentGroupIds.includes(environment.GroupId)) {
        return acc + 1;
      }
      return acc;
    },
    0
  );

  // return the modal function rather than opening the modal directly, to satisfy conditional rendering hook requirements
  return async () =>
    confirm({
      title: 'Are you sure?',
      message: `Are you sure you want to distribute ${policyName} to ${environmentGroupIds.length} environment groups across ${totalEnvironmentsAcrossGroups} environments?`,
      confirmButton: buildConfirmButton('Confirm', 'danger'),
    });
}
